<template>
  <div>
    <v-autocomplete
      v-model="editedMonthItem"
      :items="monthItemList"
      :item-text="setItemText"
      item-value="Number"
      return-object
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_results')"
      :label="$t(itemName)"
      @change="chooseItem"
      :ref="refName"
      @keyup.enter="keyupEnter"
    >
      <template v-slot:item="data">
        <template>
          <v-list-item-content>
            <v-list-item-title>{{ data.item.Number }}</v-list-item-title>
            <v-list-item-subtitle>{{ data.item.Name }}</v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </template>
      <template v-slot:selection="{ item }">
        {{ setSelectText(item) }}
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  name: 'ItemForInstallMonthAutocomplete',
  props: {
    monthItemList: {
      type: Array
    },
    editedMonthItemIndex: {
      type: Number
    },
    itemName: {
      type: String
    },
    refName: {
      type: String
    }
  },
  components: {},
  data: () => ({
    editedMonthItem: {
      Id: '',
      Number: '',
      Name: '',
      RentWarrantyPeriod: 0
    },
    defaultMonthItem: {
      Id: '',
      Number: '',
      Name: '',
      RentWarrantyPeriod: 0
    }
  }),
  async mounted () {},
  watch: {},
  methods: {
    keyupEnter (event) {
      this.$refs[this.refName].isMenuActive = false
      this.$refs[this.refName].isFocused = false
      this.$emit('keyupEnter', event)
    },
    chooseItem () {
      if (this.editedMonthItem) {
        this.$emit('setEditedItem', this.editedMonthItem)
      } else {
        this.$emit('setEditedItem', this.defaultMonthItem)
      }
    },
    setSelectText (item) {
      return item.Number
    },
    setItemText (item) {
      return item.Number + ' - ' + item.Name
    }
  }
}
</script>
